module.exports = __webpack_public_path__ + "static/media/gallery_empty@2x.01eee2c4.png";